import { createAction } from 'typesafe-actions'

import { IOsionAsetus, IAsetus } from '../reducers/OsiokohtaisetAsetuksetReducer'

export const alustaOsiokohtaisetAsetukset = createAction('OsiokohtaisetAsetuksetAlustaAsetukset')<IOsionAsetus[]>()
export const asetaOsionAsetuksienArvoja = createAction('OsiokohtaisetAsetuksetAsetaAsetuksienArvoja')<IAsetus[]>()
export const asetaOsionNimi = createAction('OsiokohtaisetAsetuksetAsetaOsionNimi')<string>()
